var map = {
	"./0.mp4": 56,
	"./1.mp4": 57,
	"./2.mp4": 58,
	"./3.mp4": 59,
	"./4.mp4": 60,
	"./5.mp4": 61,
	"./6.mp4": 62,
	"./7.mp4": 63,
	"./8.mp4": 64,
	"./9.mp4": 65,
	"./a.mp4": 66,
	"./b.mp4": 67,
	"./c.mp4": 68,
	"./d.mp4": 69,
	"./e.mp4": 70,
	"./f.mp4": 71,
	"./g.mp4": 72,
	"./h.mp4": 73,
	"./i.mp4": 74,
	"./j.mp4": 75,
	"./k.mp4": 76,
	"./l.mp4": 77,
	"./m.mp4": 78,
	"./n.mp4": 79,
	"./o.mp4": 80,
	"./p.mp4": 81,
	"./q.mp4": 82,
	"./r.mp4": 83,
	"./s.mp4": 84,
	"./t.mp4": 85,
	"./u.mp4": 86,
	"./v.mp4": 87,
	"./w.mp4": 88,
	"./x.mp4": 89,
	"./y.mp4": 90,
	"./z.mp4": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;